import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import { BiCheck } from 'react-icons/bi';

import { CheckBox } from '../../styles/commonStyles';

const CustomCheckBox = ({ label, value, onClick, onClickLabelRt, orderChange, size, style }) => {
  const [check, setCheck] = useState(value);

  useEffect(() => {
    setCheck(value);
  }, [value]);

  const clickBox = () => {
    if (onClickLabelRt) onClickLabelRt(label);
    if (onClick) onClick(!check);

    setCheck(!check);
  };

  return (
    <CheckBox active={check} size={size} style={style} orderChange={orderChange}>
      <input type='checkbox' value={check} />
      <span onClick={clickBox}>
        <BiCheck />
      </span>
      {label && <label onClick={clickBox}>{label}</label>}
    </CheckBox>
  );
};

CustomCheckBox.propTypes = {
  label: PropTypes.any,
};

export default CustomCheckBox;
